import { render } from "./WhatIOfferSection.vue?vue&type=template&id=a6a24bcc&scoped=true"
import script from "./WhatIOfferSection.vue?vue&type=script&lang=js"
export * from "./WhatIOfferSection.vue?vue&type=script&lang=js"

import "./WhatIOfferSection.vue?vue&type=style&index=0&id=a6a24bcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6a24bcc"]])

export default __exports__